import * as Yup from 'yup'
import Button from '../../../components/button/Button'
import './dailyReport.scss'
import { ROUTES_PATH } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ErrorMessage } from 'formik'
import Calendar from '../../../components/calendar/Calendar'
import { Form, Formik } from 'formik'
import { useMemo, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { useDispatch, useSelector } from 'react-redux'
import {
  addIdKeyToObject,
  convertDateFormatCalendar,
  convertTZToDate,
  exportDailyReport,
  generateDropdownOptions,
} from '../../../utility/genricFunction'
import dayjs from 'dayjs'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import { getDailyReport } from '../../../store/builders/reports/reports.builder'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { Column } from 'primereact/column'
import PrintIcon from '@mui/icons-material/Print'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

const DailyReport = () => {
  const dispatch = useDispatch()
  const { dailyReport, loading } = useSelector((state) => state?.reports)
  const authSelector = useSelector((store) => store.auth)
  const userEmail = authSelector?.user?.result?.userData?.userEmail
  const [showTable, setShowTable] = useState(false)

  const validationSchema = Yup.object().shape({
    reportDate: Yup.date().required('Report Date is required').typeError('Invalid Date'),
    branch: Yup.string().required('Branch is required'),
  })

  const branches = useSelector((state) => state?.branch?.branchTableData)
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
  const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)

  const [initialValues, setInitialValues] = useState({
    reportDate: '',
    branch: userRole == 'branch' ? branchId : '',
  })

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
});

  const dateBody = (reportData) => {
    const representative = reportData?.collectionDate && convertTZToDate(reportData?.collectionDate)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const followupDateBody = (reportData) => {
    const representative = reportData?.next_followup_date && convertTZToDate(reportData?.next_followup_date)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const EnrollDateBody = (reportData) => {
    const representative = reportData?.enrollment_date && convertTZToDate(reportData?.enrollment_date)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const feesCollectionFooterGroup = (
    <ColumnGroup>
      <Row>
        <Column footer='Total' colSpan={7} className='table-total-row' />
        <Column footer={dailyReport.totalPaidAmount} className='table-total-row' />
      </Row>
    </ColumnGroup>
  )

  const inquiryDetailsFooterGroup = (
    <ColumnGroup>
      <Row>
        <Column footer='Total' colSpan={2} className='table-total-row' />
        <Column 
        footer={dailyReport?.sourceList?.reduce((acc, source) => acc + source.telephoniccount, 0) || 0} 
        className='table-total-row' 
      />
      <Column 
        footer={dailyReport?.sourceList?.reduce((acc, source) => acc + source.walkincount, 0) || 0} 
        className='table-total-row' 
      />
      </Row>
    </ColumnGroup>
  )

  const recieptBodyTemplate = (data) => {
    
       const receiptNo = dayjs(data?.createdAt).unix()
        return (
          <span>{`${receiptNo}/${data?.batchNo}`}</span>
        )
      }
  const feesCollectionColumns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      heading: true,
      style: { minWidth: '2rem' },
    },
    {
      field: 'collectionDate',
      header: 'Collection Date',
      filter: false,
      style: { minWidth: '8rem' },
      body: dateBody,
      dataType: 'date',
    },
    {
      field: 'courseName',
      header: 'Course',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'courseCode',
      header: 'Code',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '8rem' },
    },
    {
      field: 'studentName',
      header: 'Student Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'receiptNo',
      header: 'Receipt No',
      filter: false,
      filterDisplay: 'row',
      body: recieptBodyTemplate,
      style: { minWidth: '8rem' },
    },
    {
      field: 'paymentMode',
      header: 'Mode',
      filter: false,
      filterDisplay: 'row',
    },
    {
      field: 'paidAmount',
      header: 'Paid Amount',
      filter: false,
    },
  ]

  const inquiryColumns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      heading: true,
      style: { minWidth: '1rem' },
    },
    {
      field: 'inquiry_source_name',
      header: 'Inquiry Source',
      filter: false,
      style: { minWidth: '12rem' },
    },
    {
      field: 'telephoniccount',
      header: 'Telephonic',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'walkincount',
      header: 'Walkin',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
  ]

  const TelephonicColumns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      heading: true,
      style: { minWidth: '2rem' },
    },
    {
      field: 'name',
      header: 'Name',
      filter: false,
      style: { minWidth: '8rem' },
    },
    {
      field: 'inquiry_status',
      header: 'Status',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'next_followup_date',
      header: 'Next Followup Date',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
      body: followupDateBody,
      dataType: 'date',
    },
    {
      field: 'remarks',
      header: 'Followup Remarks',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
  ]

  const walkinColumns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      heading: true,
      style: { minWidth: '2rem' },
    },
    {
      field: 'name',
      header: 'Name',
      filter: false,
      style: { minWidth: '8rem' },
    },
    {
      field: 'inquiry_status',
      header: 'Status',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'next_followup_date',
      header: 'Next Followup Date',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
      body: followupDateBody,
      dataType: 'date',
    },
    {
      field: 'remarks',
      header: 'Followup Remarks',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
  ]

  const enrollColumns = [
    {
      field: 'id',
      header: '#',
      filter: false,
      heading: true,
      style: { minWidth: '2rem' },
    },
    {
      field: 'name',
      header: 'Name',
      filter: false,
      style: { minWidth: '8rem' },
    },
    {
      field: 'email',
      header: 'Email',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'phone',
      header: 'Phone',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'course_name',
      header: 'Course Name',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
    },
    {
      field: 'enrollment_date',
      header: 'Enrollment Date',
      filter: false,
      body: EnrollDateBody,
      filterDisplay: 'row',
      style: { minWidth: '10rem' },
      dataType: 'date',
    },
  ]

  const breadCrumbsArr = [
    {
      title: 'Daily Report',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Daily Report',
      link: ROUTES_PATH.DAILY_REPORT,
    },
  ]

  const tables = [
    {
      title: 'Fees Collection Details',
      headers: feesCollectionColumns,
      data: addIdKeyToObject(dailyReport.paymentDetails),
      footers: ['', '', '', '', '', '', '', dailyReport.totalPaidAmount],
    },
    {
      title: 'Inquiry Details',
      headers: inquiryColumns,
      data: addIdKeyToObject(dailyReport.sourceList),
      footers: ['', '', 0, 0],
    },
    {
      title: `Telephonic \t \t \t \t \t \t   ${dailyReport.telephonicInquiryCount}`,
      headers: TelephonicColumns,
      data: addIdKeyToObject(dailyReport.telephonicInquiry),
      footers: [],
    },
    {
      title: `Walkin \t \t \t \t \t \t   ${dailyReport.walkinInquiryCount}`,
      headers: walkinColumns,
      data: addIdKeyToObject(dailyReport.walkinInquiry),
      footers: [],
    },
    {
      title: `Enrollment \t \t \t \t \t \t   ${dailyReport.enrollInquiryCount}`,
      headers: enrollColumns,
      data: addIdKeyToObject(dailyReport.enrollInquiry),
      footers: [],
    },
  ]

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> &&  <div className='daily-report-wrapper'>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(value) => {
          setShowTable(true)
          const data = { Date: dayjs(value.reportDate).format('YYYY-MM-DD'), branchId: value.branch }
          dispatch(getDailyReport(data))
        }}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className='time-table-report-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
            <div className='time-table-report-main-div'>
              <div className='time-table-report-input-fields'>
                <div className='daily-report-inner-wrapper'>
                  <Calendar
                    label='Report Date'
                    name='reportDate'
                    width={'100%'}
                    required={true}
                    onChange={(values) => setFieldValue('reportDate', convertDateFormatCalendar(values))}
                  />

                  <div className='time-table-report-dropdown'>
                    <label htmlFor=''>
                      Branch<span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      className={'facultyForm-dropdown'}
                      name={'branch'}
                      placeholder={'Select Branch'}
                      options={branchOption}
                      selectedValue={values.branch}
                      onChange={handleChange}
                      disabled={userRole == 'branch'}
                    />
                    <ErrorMessage name='branch' component='div' className='error-msg' />
                  </div>

                  <div className='submit-btn-wrapper'>
                    <Button type='submit' customClassName={'tt-report-btn-submit'}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {showTable && (
              <div className='time-table-report-table-div'>
                <div className='export-option-wrapper'>
                  <Button
                    text={'Send Mail'}
                    type={'button'}
                    onClick={() => exportDailyReport(tables, 'Daily Report', 'DailyReport.xlsx', 'Mail', dispatch, userEmail)}
                  >
                    Send Mail
                  </Button>

                  <div className='pdf-excel-export'>
                    <Button
                      text={'Export'}
                      type={'button'}
                      onClick={() => exportDailyReport(tables, 'Daily Report', 'DailyReport.xlsx', 'Export')}
                    >
                      <SimCardDownloadIcon />
                    </Button>
                    <Button text={'Export'} type={'button'} onClick={handleDownloadPfd}>
                      <PrintIcon />
                    </Button>
                  </div>
                </div>


                <div className='printable-component' ref={printRef}>

                <div className='report-heading-label-div'>{'Fees Collection Details '}</div>
                <ReportDataTable
                  columns={feesCollectionColumns}
                  value={addIdKeyToObject(dailyReport.paymentDetails)}
                  footerColumnGroup={feesCollectionFooterGroup}
                />

                <div className='report-heading-label-div'>{'Inquiry Details'}</div>
                <ReportDataTable
                  columns={inquiryColumns}
                  value={addIdKeyToObject(dailyReport.sourceList)}
                  footerColumnGroup={inquiryDetailsFooterGroup}
                />

                <div className='report-heading-label-div'>
                  {'Followup: '}
                  {dailyReport.telephonicInquiryCount + dailyReport.walkinInquiryCount}
                </div>

                <div className='report-heading-label-div daily-report-count-data'>
                  <span>Telephonic</span>
                  <span> {dailyReport.telephonicInquiryCount}</span>
                </div>
                <ReportDataTable columns={TelephonicColumns} value={addIdKeyToObject(dailyReport.telephonicInquiry)} />

                <div className='report-heading-label-div daily-report-count-data'>
                  <span>Walkin</span>
                  <span> {dailyReport.walkinInquiryCount}</span>
                </div>
                <ReportDataTable columns={walkinColumns} value={addIdKeyToObject(dailyReport.walkinInquiry)} />

                <div className='report-heading-label-div daily-report-count-data'>
                  <span>Enrollment</span>
                  <span> {dailyReport.enrollInquiryCount}</span>
                </div>
                <ReportDataTable columns={enrollColumns} value={addIdKeyToObject(dailyReport.enrollInquiry)} />
              </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>}
    </>
  )
}

export default DailyReport
